import React, { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "../../components/Ad.css";
import Header from "../Component/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPersonCircleCheck,
  faMoneyBillTransfer,
  faComment,
  faBookOpenReader,
  faChalkboardUser,
  faHourglassHalf,
  faCalendarAlt,
  faMoneyCheckDollar,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";
import "react-calendar/dist/Calendar.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import LearnImage from '../images/Learn.jpeg'
import LearnImage from "../../images/learn.jpg";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Link } from "react-router-dom";
import { faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
import axios, { renderDoc } from "../../Axiosinstance";
import { encryptData } from "../../Axiosinstance";

import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  TablePagination,
  Card,
  CardContent,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  DialogContentText,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

import { Button, Modal, Spinner } from "react-bootstrap";

import {
  faUserGraduate,
  faUserTie,
  faLayerGroup,
  faChalkboard,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import Studentreq from "../../components/Studentreq";
import StudentPayment from "../../components/StudentPayments";
import { Tabs, Tab, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  faTasks,
  faProjectDiagram,
  faBell,
  faTicketAlt,
  faBullhorn,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import { FaChalkboardTeacher } from "react-icons/fa";
import { format } from "date-fns";
import Editstudent from "../../components/EditStudent";
import Offlinepayments from "../../components/Offlinepayments";
import Defferred from "../../components/Defferred";
import Enqiuery from "../../components/Enqiuery";
import CircularProgress from "@material-ui/core/CircularProgress";
import { removeBracketedText } from "../../Axiosinstance";
import Pending from "../../components/Pending";
import { CategoryStudentWise } from "../../components/CategoryStudentWise";
import RegistrationRequest from "./Dashboard/RegistrationRequest";

const Ap = () => {
  return (
    <div
      className="container"
      style={{ textAlign: "center", padding: "30px", marginTop: "-2%" }}
    >
      <h1
        className="welcome-heading"
        style={{
          color: "#2186C8",
          fontSize: "2.8rem",
          fontWeight: "bold",
          marginBottom: "8px",
          textShadow:
            "2px 2px 0px white, -2px -2px 0px white, 2px -2px 0px white, -2px 2px 0px white",
        }}
      >
        <span id="head" style={{ color: "#2186C8" }}>
          JURONG ACADEMY
        </span>
      </h1>
      <h4
        className="welcome-heading"
        style={{
          color: "#d4af37",
          fontSize: "1.2rem",
          fontWeight: "bold",
          marginBottom: "10px",
        }}
      >
        Learning Management System
      </h4>
    </div>
  );
};

const Dashboard = () => {
  const [studentdata1, setstudentdata1] = useState(0);
  const [staffdata2, setstaffdata2] = useState(0);
  const [batchdata3, setbatchdata3] = useState(0);
  const [coursesdata4, setcoursesdata4] = useState(0);
  const [activeStudent, setActiveStudent] = useState(0);
  const [counts, setCounts] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          response1,
          response2,
          response3,
          response4,
          response5,
          response6,
        ] = await Promise.all([
          axios.get("student/count"),
          axios.get("facilitator/count"),
          axios.get("course/count"),
          axios.get("category/count"),
          axios.get("courses/countByType"),
          axios.get("student/count/active"),
        ]);
        setstudentdata1(response1.data);
        setstaffdata2(response2.data);
        setbatchdata3(response3.data);
        setcoursesdata4(response4.data);
        setCounts(response5.data);
        setActiveStudent(response6.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const totals = [
    // { name: 'Total Students', count: studentdata1, icon: faUserGraduate, path: '/Allstudent' },
    {
      name: "Active Students",
      count: activeStudent,
      icon: faUserGraduate,
      path: "/Allstudent",
    },
    {
      name: "Total Staff",
      count: staffdata2,
      icon: faChalkboardUser,
      path: "/Facilitor",
    },
    // { name: 'Department wise Student', count: 30, icon: faLayerGroup, path: '/Allstudent' },
    {
      name: "Total Courses",
      count: counts.diploma,
      icon: faBookOpenReader,
      path: "/AllCourse",
    },
    {
      name: "Total Batch ",
      count: counts.advance_diploma,
      icon: faBook,
      path: "/AllCourse",
    },
    {
      name: "Sales Person ",
      count: counts.advance_diploma,
      icon: faUserTie,
      path: "/sales",
    },
    {
      name: "Total Batch ",
      count: counts.advance_diploma,
      icon: faBook,
      path: "/AllCourse",
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        padding: "20px",
        backgroundColor: "rgba(255, 255, 255, 0.3)", // White with 50% opacity
        borderRadius: "10px",
        boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)", // Shadow effect
        maxWidth: "1450px",
        margin: "0 auto",
        flexWrap: "wrap",
      }}
    >
      {/* Narrow rectangle outside the image */}
      {/* <div
        style={{
          position: 'absolute',
          top: '-60px', // Placed outside and above the image
          right: '0',
          left: '0', // Center it horizontally
          margin: '0 auto',
          width: '100%', // Adjust width as needed
          height: '60px', // Narrow rectangle height
          // backgroundColor: '#ffffff',
          borderRadius: '10px',
          // boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)', // Shadow effect
          display: 'flex',
          alignItems: 'center',
          // justifyContent: 'center', // Center content horizontally
          zIndex: 2, // Ensure it's above the image
          padding: '10px 20px',
        }}
      > */}
      {/* <img src={Logo} alt="Logo" style={{ width: '40px', marginRight: '15px' }} /> */}
      {/* <h2 style={{ color: '#FFFFFF', fontSize: '1.8rem', fontWeight: 'bold', margin: 0 }}>Student Dashboard</h2> */}
      {/* </div> */}

      {totals.map((item, index) => (
        <div
          key={index}
          onClick={() => handleNavigation(item.path)}
          style={{
            width: "320px",
            height: "140px",
            borderRadius: "12px",
            boxShadow:
              hoverIndex === index
                ? "0 8px 15px rgba(0, 0, 0, 0.2)"
                : "0 4px 6px rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px",
            margin: "10px",
            cursor: "pointer",
            transition: "transform 0.4s ease, box-shadow 0.3s ease",
            transform: hoverIndex === index ? "scale(1.05)" : "scale(1)",
            background:
              hoverIndex === index
                ? "linear-gradient(135deg, #83a4d4, #b6fbff)"
                : "linear-gradient(135deg, #ffffff, #e6e6e6)",
          }}
          onMouseEnter={() => setHoverIndex(index)}
          onMouseLeave={() => setHoverIndex(null)}
        >
          <div style={{ flex: 1, textAlign: "left" }}>
            <div
              style={{
                fontSize: "32px",
                fontWeight: "bold",
                marginBottom: "5px",
                color: "#0E6060",
              }}
            >
              {item.count}
            </div>
            <div
              style={{ fontSize: "20px", fontWeight: "bold", color: "#505D6A" }}
            >
              {item.name}
            </div>
          </div>
          <div
            style={{
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FontAwesomeIcon
              icon={item.icon}
              style={{ fontSize: "40px", color: "#d4af37" }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

const WelcomeBoxes = () => {
  const [count, setCount] = useState();
  const [countStudent, setCountStudent] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showStudentReq, setShowStudentReq] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showOffline, setShowOffline] = useState(false);
  const [showdefferred, setShowdefferred] = useState(false);
  const [showenqiuery, setShowenqiuery] = useState(false);
  const [showPending, setShowPending] = useState(false);

  const [unapprovedCount, setUnapprovedCount] = useState();

  const navigate = useNavigate();

  const handleOpenOffline = () => {
    setShowOffline(true);
  };

  const handleCloseOffline = () => {
    setShowOffline(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await axios.get("batch/count");
        const response2 = await axios.get("requeststudents/count");
        const response3 = await axios.get("/wsq/students/new/count");
        setCount(response1.data);
        setCountStudent(response2.data);
        setUnapprovedCount(response3.data);
      } catch (error) {
        console.error("Error fetching batch count:", error);
      }
    };

    fetchData();
  }, []);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleOpenStudentReq = () => {
    setShowStudentReq(true);
  };

  const handleCloseStudentReq = () => {
    setShowStudentReq(false);
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
  };

  const handleOpendefferred = () => {
    setShowdefferred(true);
  };

  const handleClosedefferred = () => {
    setShowdefferred(false);
  };

  const handleOpenenqiuery = () => {
    setShowenqiuery(true);
  };

  const handleCloseenqiuery = () => {
    setShowenqiuery(false);
  };

  const handleOpenPending = () => {
    setShowPending(true); // Open Pending modal
  };

  const handleClosePending = () => {
    setShowPending(false); // Close Pending modal
  };

  const [hoveredCard, setHoveredCard] = useState(null);

  const handleMouseEnter = (index) => setHoveredCard(index);
  const handleMouseLeave = () => setHoveredCard(null);

  const cards = [
    {
      title: "Approve Registration",
      description: "View and Approve Registration",
      icon: faPersonCircleCheck,
      count: unapprovedCount,
      onClick: openModal,
    },
    {
      title: "New Student Manual Payments",
      description: "View and students Payments Detail",
      icon: faMoneyBillTransfer,
      onClick: handleOpenOffline,
    },

    {
      title: "Offline Payment",
      description: "View Offline Payment Details",
      icon: faMoneyCheckDollar,
      onClick: handleOpenStudentReq,
    },
  ];

  return (
    <>
      <div
        className="container"
        style={{
          maxWidth: "1450px",
          margin: "0 auto",
          padding: "20px",
          backgroundColor: "rgba(255, 255, 255, 0.3)", // White with 50% opacity
          borderRadius: "20px",
          boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-60px", // Placed outside and above the image
            right: "0",
            left: "0", // Center it horizontally
            margin: "0 auto",
            width: "100%", // Adjust width as needed
            height: "60px", // Narrow rectangle height
            // backgroundColor: '#ffffff',
            borderRadius: "10px",
            // boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)', // Shadow effect
            display: "flex",
            alignItems: "center",
            // justifyContent: 'center', // Center content horizontally
            zIndex: 2, // Ensure it's above the image
            padding: "10px 20px",
          }}
        >
          {/* <img src={Logo} alt="Logo" style={{ width: '40px', marginRight: '15px' }} /> */}
          {/* <h2 style={{ color: '#FFFFFF', fontSize: '1.8rem', fontWeight: 'bold', margin: 0 }}>Admin Dashboard</h2> */}
        </div>

        <Grid container spacing={4} justifyContent="center">
          {cards.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                onClick={card.onClick}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
                sx={{
                  borderRadius: 12,
                  backgroundColor: "#ffffff",
                  padding: 2,
                  textAlign: "center",
                  transition: "transform 0.4s ease, box-shadow 0.3s ease",
                  transform: hoveredCard === index ? "scale(1.05)" : "scale(1)",
                  background:
                    hoveredCard === index
                      ? "linear-gradient(135deg, #83a4d4, #b6fbff)"
                      : "linear-gradient(135deg, #ffffff, #e6e6e6)",

                  cursor: "pointer",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  paddingBottom: "20px", // Added space at the bottom
                  border: "1px solid #e0e0e0", // Light border for definition
                }}
              >
                <CardContent>
                  <div
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                      marginRight: "15px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={card.icon}
                      size="3x"
                      style={{
                        color: hoveredCard === index ? "#007bff" : "#d4af37",
                        transition: "color 0.3s ease",
                      }}
                    />
                  </div>
                  <div
                    style={{ display: "inline-block", verticalAlign: "middle" }}
                  >
                    <Typography
                      variant="h5"
                      component="h3"
                      style={{
                        fontSize: "32px",
                        fontWeight: "bold",
                        color: "#0E6060",
                      }}
                    >
                      {card.count}
                    </Typography>
                  </div>

                  <Typography
                    variant="h5"
                    component="h3"
                    style={{
                      color: "#373ABB",
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    {card.title}
                  </Typography>

                  {card.description && (
                    <Typography
                      variant="body2"
                      style={{ color: "#373ABB", margin: "10px 0" }}
                    >
                      {card.description}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Modal
          show={showModal}
          onHide={closeModal}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>New Registration</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RegistrationRequest />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showStudentReq}
          onHide={handleCloseStudentReq}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Offline Payments</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Studentreq />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseStudentReq}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showOffline}
          onHide={handleCloseOffline}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Offline Payments for new student</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Offlinepayments />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseOffline}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showPaymentModal}
          onHide={handleClosePaymentModal}
          dialogClassName="modal-fullscreen"
        >
          <Modal.Header closeButton>
            <Modal.Title>Students Payments</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <StudentPayment />
            <ToastContainer />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClosePaymentModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

const Adhome = () => {
  return (
    <div
      style={{
        // backgroundImage: `url(${Cap})`,
        // backgroundSize: 'cover', // Cover the entire div
        // backgroundPosition: 'center', // Center the image
        // minHeight: '100vh',
        // backgroundRepeat: 'no-repeat', // Prevents image repetition
        background: "#285588",
        // height: '100vh', // Adjust the height as per your requirement
        // padding: '20px', // Optional padding
      }}
    >
      <Header />
      <br />
      <div style={{ flexDirection: "column", alignItems: "center" }}>
        <Ap />
        <br /> <br />
        <Dashboard />
        <br /> <br /> <br />
        <WelcomeBoxes />
        <br /> <br />
        {/* <div
          style={{
            maxWidth: '1450px',
            margin: '0 auto',
            position: 'relative', // Position for absolute positioning of common name
            backgroundColor: 'rgba(255, 255, 255, 0.3)', // White with 50% opacity
            borderRadius: '10px',
            boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)', // Shadow effect
            padding: '10px', // Optional: for spacing
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Optional: shadow effect
          }}
        >
          <div
            style={{
              position: 'absolute',
              color: 'white',
              top: '16px',
              left: '16px',
              fontWeight: 'bold',
              fontSize: '1.6em', // Adjust the size as needed
              zIndex: 1, // Ensure it is above other content
            }}
          >
            Course Catergories
          </div>

          <CategoryStudentWise />
        </div> */}
      </div>
    </div>
  );
};

export default Adhome;
